import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Frontend/Home.vue'
import ShopFinder from '../views/Frontend/ShopFinder.vue'
import Shops from '../views/Frontend/Shoplist.vue'
import Shop from '../views/Frontend/ShopDetails.vue'
import Search from "../views/Frontend/Search";
import NaviConfig from "../views/Backend/NaviConfig";
import NaviTest from "../views/Backend/NaviTest";
import Frontend from "../views/Frontend/Frontend";
import Backend from "../views/Backend/Backend";
import LocalConfig from "../views/Backend/LocalConfig";
import ShopnumberConfig from "../views/Backend/ShopnumberConfig";
import Werbung from "../views/Backend/Werbung";
import Services from "@/views/Frontend/Services";
import StartDescriptions from "@/views/Backend/StartDescriptions";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Frontend',
    component: Frontend,
    props: true,
    children: [
      {
        path: '/',
        component: Home,
        props: true,
        name: 'Home'
      },
      {
        path: '/shopfinder',
        name: 'ShopFinder',
        component: ShopFinder,
        props: true
      },
      {
        path: '/shops/:filter/:filterValue',
        name: 'Shops',
        component: Shops
      },
      {
        path: '/shop/:id',
        name: 'ShopDetails',
        component: Shop,
        props: true
      },
      {
        path: '/services',
        name: 'Services',
        component: Services,
        props: true
      },
      {
        path: '/search',
        name: 'Search',
        component: Search,
        props: true,
      },
    ]
  },
  {
    path:'/backend',
    component: Backend,
    props: true,
    children: [
      {
        path: 'naviconfig',
        name: 'NaviConfig',
        component: NaviConfig
      },
      {
        path: 'navitest',
        name: 'NaviTest',
        component: NaviTest
      },
      {
        path: 'localconfig',
        component: LocalConfig,
        props: true
      },
      {
        path: 'shopnumberconfig',
        component: ShopnumberConfig,
        props: true
      },
      {
        path: 'werbung',
        component: Werbung,
        props: true
      },
      {
        path: 'startdesc',
        component: StartDescriptions,
        props: true
      }

    ]
  },
]

const router = new VueRouter({
  routes
})

export default router
